import { IDriversLicenseExtractionResponse } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { DataItemProps } from "../../../../../../shared/components/DataView";
import { convertDateStringToUTCMidday } from "../../../../../../utils/dates";
import { toWSDateString } from "@wingspanhq/fe-component-library";

export const mapDriversLicenseExtractedFieldsToDataView = (
  extractedFields: IDriversLicenseExtractionResponse
): DataItemProps[] => {
  const dataItems: DataItemProps[] = [];

  if (extractedFields.personalInfo?.firstName) {
    dataItems.push({
      label: "First name",
      value: extractedFields.personalInfo.firstName
    });
  }

  if (extractedFields.personalInfo?.middleName) {
    dataItems.push({
      label: "Middle name",
      value: extractedFields.personalInfo.middleName
    });
  }

  if (extractedFields.personalInfo?.lastName) {
    dataItems.push({
      label: "Last name",
      value: extractedFields.personalInfo.lastName
    });
  }

  if (extractedFields.personalInfo?.suffix) {
    dataItems.push({
      label: "Suffix",
      value: extractedFields.personalInfo.suffix
    });
  }

  if (extractedFields.personalInfo?.dateOfBirth) {
    dataItems.push({
      label: "Date of birth",
      value: toWSDateString(
        convertDateStringToUTCMidday(extractedFields.personalInfo.dateOfBirth),
        "monthDayYear"
      )
    });
  }

  if (extractedFields.personalInfo?.sex) {
    dataItems.push({
      label: "Sex",
      value: extractedFields.personalInfo.sex
    });
  }

  if (extractedFields.licenseInfo?.licenseNumber) {
    dataItems.push({
      label: "License number",
      value: extractedFields.licenseInfo.licenseNumber
    });
  }

  if (extractedFields.licenseInfo?.licenseClass) {
    dataItems.push({
      label: "License class",
      value: extractedFields.licenseInfo.licenseClass
    });
  }

  if (extractedFields.licenseInfo?.issueDate) {
    dataItems.push({
      label: "Issue date",
      value: toWSDateString(
        convertDateStringToUTCMidday(extractedFields.licenseInfo.issueDate),
        "monthDayYear"
      )
    });
  }

  if (extractedFields.licenseInfo?.expirationDate) {
    dataItems.push({
      label: "Expiration date",
      value: toWSDateString(
        convertDateStringToUTCMidday(
          extractedFields.licenseInfo.expirationDate
        ),
        "monthDayYear"
      )
    });
  }

  if (extractedFields.licenseInfo?.issuingState) {
    dataItems.push({
      label: "Issuing state",
      value: extractedFields.licenseInfo.issuingState
    });
  }

  if (extractedFields.licenseInfo?.issuingCountry) {
    dataItems.push({
      label: "Issuing country",
      value: extractedFields.licenseInfo.issuingCountry
    });
  }

  if (extractedFields.physicalDescriptors?.height) {
    dataItems.push({
      label: "Height",
      value: extractedFields.physicalDescriptors.height
    });
  }

  if (extractedFields.physicalDescriptors?.weight) {
    dataItems.push({
      label: "Weight",
      value: extractedFields.physicalDescriptors.weight
    });
  }

  if (extractedFields.physicalDescriptors?.eyeColor) {
    dataItems.push({
      label: "Eye color",
      value: extractedFields.physicalDescriptors.eyeColor
    });
  }

  if (extractedFields.physicalDescriptors?.hairColor) {
    dataItems.push({
      label: "Hair color",
      value: extractedFields.physicalDescriptors.hairColor
    });
  }

  if (extractedFields.address?.streetAddress) {
    dataItems.push({
      label: "Street address",
      value: extractedFields.address.streetAddress
    });
  }

  if (extractedFields.address?.city) {
    dataItems.push({
      label: "City",
      value: extractedFields.address.city
    });
  }

  if (extractedFields.address?.state) {
    dataItems.push({
      label: "State",
      value: extractedFields.address.state
    });
  }

  if (extractedFields.address?.zipCode) {
    dataItems.push({
      label: "Zip code",
      value: extractedFields.address.zipCode
    });
  }

  if (extractedFields.restrictions?.length) {
    dataItems.push({
      label: "Restrictions",
      value: extractedFields.restrictions.join(", ")
    });
  }

  if (extractedFields.organDonor) {
    dataItems.push({
      label: "Organ donor",
      value: extractedFields.organDonor ? "Yes" : "No"
    });
  }

  return dataItems;
};
